const IMAGE_DIM = {
  width: 106,
  height: 76,
  marginRight: 8,
};
export const initialImageContainerLeftMargin = 10;

export const getFullyShownImagesCount = (width) => {
  if (!width) {
    return 0;
  }

  const itemWidth = IMAGE_DIM.width + IMAGE_DIM.marginRight;

  return Math.floor(width / itemWidth);
};

export const getCarouselStyles = (components, { palette = {} } = {}, iconFontFamily = 'MsAds MDL2 Assets') => ({
  carouselParent: {
    position: 'relative',
    display: 'inline-flex',
    width: '100%',
    alignItems: 'end',
  },
  disabledCarouselParent: {
    pointerEvents: 'none',
    opacity: 0.4,
  },
  image: {
    ...IMAGE_DIM,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    objectFit: 'cover',
    borderRadius: 6,
  },
  imageContainer: ({ imageContainerLeftMargin }) => ({
    height: IMAGE_DIM.height,
    overflowX: 'hidden',
    overflowY: 'hidden',
    display: 'inline-block',
    marginLeft: imageContainerLeftMargin,
    flexGrow: 1,
  }),
  imageParentContainer: ({ imageParentLeftOffset, numberOfImages }) => ({
    width: (IMAGE_DIM.width + IMAGE_DIM.marginRight) * numberOfImages,
    position: 'relative',
    left: ((-1 * IMAGE_DIM.width) - IMAGE_DIM.marginRight) * imageParentLeftOffset,
  }),
  imageClickableContainer: {
    display: 'inline',
    '& :hover': {
      cursor: 'pointer',
    },
  },
  loadingMessageContainer: {
    marginTop: 16,
    marginLeft: 16,
  },
  loadingText: {
    display: 'inline-block',
    fontSize: '12px',
    lineHeight: '16px',
    verticalAlign: 'top',
  },
  panel: {},
  panelHeading: {
    display: 'flex',
  },
  panelTitle: {
    flexGrow: 0,
  },
  panelIcon: {
    marginRight: 3,
    paddingBottom: 12,
    '&:before': {
      fontFamily: iconFontFamily,
      content: '"\\E3AF"',
    },
  },
  panelHelpButton: {
    display: 'flex',
    '& .helpbutton': {
      margin: '4px 0px',
    },
  },
  imageHintRight: {
    display: 'inline-block',
    position: 'absolute',
    background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: 20,
    height: IMAGE_DIM.height,
    right: 32,
  },
  imageHintLeft: {
    display: 'inline-block',
    position: 'absolute',
    background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: 30,
    height: IMAGE_DIM.height,
    left: 34,
    transform: 'rotate(-180deg)',
  },
  paddleBtn: {
    bottom: '18px',
  },
  moreIcon: {
    fontSize: '18px',
    height: '60px',
    width: '33px',
    color: palette.themeDarkAlt,
  },
  seeAll: {
    display: 'inline-block',
    position: 'absolute',
    right: 0,
    bottom: 12,
    whiteSpace: 'nowrap',
    maxWidth: 50,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  seeAllInHeader: {
    marginLeft: 'auto',
    '& a': {
      position: 'static',
      color: palette.themePrimary,
      fontSize: 12,
      '&:hover, $:acitve, $:focus': {
        color: palette.themeDarkAlt,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  spinner: {
    ...components.getBlockerStyle(16, palette),
    display: 'inline-block',
    lineHeight: '16px',
  },
  parentContainer: {
    '& $panel': { // need more selector specificity to override styles applied to top of grid panels
      marginLeft: 0,
      marginTop: 12,
    },
    '& $panelHeading': {
      border: 'none',
      '& $panelTitle.collapsible-title': {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '24px',
        '& > a': {
          '& .helpbutton': {
            fontSize: '14px',
            lineHeight: '24px',
            display: 'inline',
            verticalAlign: 'bottom',
          },
        },
        marginTop: 0,
      },
    },
    '& + .alert-info': {
      marginTop: 8,
      '& a': {
        color: palette.themeDarkAlt,
      },
    },
  },
});

export const getImageSuggestionCarouselStyles = (_components, { palette } = {}) => ({
  ImageSuggestionCarouselContainer: {
    '& .image-suggestion-carousel-root': {
      '& .collapsible-title > a': {
        fontSize: 12,
        fontWeight: 600,
        '&:hover': {
          background: 'transparent',
        },
      },
    },
  },
  InfoMessageBar: {
    marginTop: '16px',
    background: palette.themeLighterAlt,
  },
});
